<template>
    <div id="opp_form_modal">
        <!-- <svg v-on:click="closeModal" height="25" width="25" class="close_button">
            <line x1="2" y1="2" x2="23" y2="23"></line>
            <line x1="23" y1="2" x2="2" y2="23"></line>
        </svg> -->
        <form @submit.prevent="updatePost">
            <p>Edit Opportunity</p>

            <label>
                Company Name
                <input type="text" name="company_name" v-model="company_name">
            </label>

            <label>
                Company Type
                <select v-model="company_type">
                    <option v-for="(option, index) in companyTypes" :key="index" :value="option">{{option}}</option>
                </select>
            </label>

            <label>
                Line(s) of Business
                <select v-model="lines_of_business">
                    <option v-for="(option, index) in businessLines" :key="index" :value="option">{{option}}</option>
                </select>
            </label>

            <label>
                Client Type
                <select v-model="client_type">
                    <option v-for="(option, index) in clientTypes" :key="index" :value="option">{{option}}</option>
                </select>
            </label>

            <label>
                Contract Type
                <select v-model="contract_type">
                    <option v-for="(option, index) in contractTypes" :key="index" :value="option">{{option}}</option>
                </select>
            </label>

            <label>
                Contact Name
                <input type="text" name="contact_name" v-model="contact_name">
            </label>

            <label>
                Contact Number
                <input type="tel" name="contact_number" v-model="contact_number">
            </label>

            <label>
                Email Address
                <input type="email" name="email_address" v-model="email_address">
            </label>

            <label v-if="user.user_role == 'User'">
                Opportunity Owner
                <input type="text" name="opportunity_owner" v-model="opportunity_owner.name" readonly>
            </label>
            <label v-else>
                Opportunity Owner
                <!-- <input type="text" name="opportunity_owner" v-model="opportunity_owner" readonly> -->
                <select v-model="opportunity_owner">
                    <option v-for="(user, index) in getCompanyUsers" :key="index" :value="user">{{user.name}}</option>
                </select>
            </label>

            <label>
                Division
                <select v-model="division">
                    <option 
                        v-for="(div, index) in divisions" 
                        v-bind:key="index" 
                        v-bind:value="div"
                    >
                    {{div}}
                    </option>
                </select>
            </label>

            <label>
                Decision Maker Name
                <input type="text" name="decision_maker" v-model="decision_maker">
            </label>

            <label>
                Date Created
                <input type="text" name="date_added" v-model="date_added" readonly>
            </label>

            <label>
                Annual Jobs
                <input 
                    type="number"
                    step="1"
                    min="1"
                    v-model.number="annual_jobs"
                    v-on:input="calculateAnnualValue"
                >
            </label>

            <label>
                Average Fee
                <input type="text" name="average_fee" v-model="average_fee" v-on:input="calculateAnnualValue" class="currency">
            </label>

            <label>
                Annual Value
                <input type="text" name="annual_value" v-model="annual_value" readonly>
            </label>

            <label>
                Next Steps
                <input type="text" name="next_steps" v-model="next_steps">
            </label>

            <label>
                Due Date
                <input type="date" name="due_date" v-model="due_date">
            </label>

            <label>
                Close By Date
                <input type="date" v-model="close_by_date">
            </label>

            <label>
                Pipeline Stage
                <select name="pipeline_stage" v-model="pipeline_stage">
                    <option disabled="" selected="" value="">Select Option</option>
                    <option value="0">Opportunity</option>
                    <option value="1">Prospect</option>
                    <option value="2">Proposal</option>
                    <option value="3">Presentation</option>
                    <option value="4">Won</option>
                    <option value="5">Lost</option>
                    <option value="6">No Opportunity</option>
                </select>
            </label>

            <label>
                Notes
                <textarea v-model="notes"></textarea>
            </label>

            <button type="button" v-on:click="confirmDeleteModal = true">
                Delete
                <svg viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
            </button>

            <button class="button" v-on:click="closeModal">Close</button>

            <button type="submit">Submit</button>

            <div id="confirm-delete" v-if="confirmDeleteModal">
                <p>Are you sure delete this ISO?</p>

                <button class="no" v-on:click="confirmDeleteModal = false">No</button>

                <button class="yes" v-on:click="deletePost">Yes</button>
            </div>

            <div v-if="validation.error" class="form-error">
                <p>{{ validation.msg }}</p>
                <button v-on:click="validation.error = false">Ok</button>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'oppForm',
        props: {
            postData: Object
        },
        computed: {
            ...mapGetters([
                'divisions',
                'businessLines',
                'clientTypes',
                'contractTypes',
                'companyTypes',
                'user',
                'getCompanyUsers'
            ]),
        },
        data() {
            return {
                id: '',
                company_name: '',
                company_type: '',
                lines_of_business: '',
                client_type: '',
                contract_type: '',
                contact_name: '',
                contact_number: '',
                email_address: '',
                opportunity_owner: {},
                division: '',
                decision_maker: '',
                date_added: '',
                annual_jobs: '',
                average_fee: '',
                annual_value: '',
                next_steps: '',
                due_date: '',
                close_by_date: '',
                pipeline_stage: '',
                notes: '',
                confirmDeleteModal: false,
                validation: {
                    error: false,
                    msg: ''
                },
                // originalColumnIndex: ''
            }
        },
        created() {
            this.get_iso_data();
            this.getBusinessLines();
            this.getClientTypes();
            this.getContractTypes();
            this.getCompanyTypes();
        },
        methods: {
            ...mapActions([
                'getAllBoardPostData',
                'getBusinessLines',
                'getClientTypes',
                'getContractTypes',
                'getCompanyTypes'
            ]),
            get_iso_data() {
                // setting date format
                let date = new Date(parseInt(this.postData.created_at));
                let dateDay = (date.getDay().toString().length < 2 ? '0' + date.getDay().toString() : date.getDay());
                let dateMonth = (date.getMonth().toString().length < 2 ? '0' + date.getMonth().toString() :date.getMonth());
                let dateYear =  new Date(parseInt(this.postData.created_at)).getFullYear();

                // setting currency format
                this.average_fee = '£' + parseInt(this.postData.average_fee).toLocaleString('en-GB');
                this.annual_value = '£' + parseInt(this.postData.annual_value).toLocaleString("en-GB");

                this.id = this.postData._id;
                this.date_added = dateDay + '/' + dateMonth + '/' + dateYear;
                this.pipeline_stage = this.postData.column_index;
                this.company_name = this.postData.company_name;
                this.company_type = this.postData.company_type;
                this.lines_of_business = this.postData.lines_of_business;
                this.client_type = this.postData.client_type;
                this.contract_type = this.postData.contract_type;
                this.contact_name = this.postData.contact_name;
                this.contact_number = this.postData.contact_number;
                this.email_address = this.postData.email_address;
                
                this.decision_maker = this.postData.decision_maker;
                this.annual_jobs = this.postData.annual_jobs;
                this.next_steps = this.postData.next_steps;
                this.due_date = this.postData.due_date;
                this.close_by_date = this.postData.close_by_date;
                this.division = this.postData.division;
                this.notes = this.postData.notes;
                this.opportunity_owner = {_id: this.postData.author_id, name: this.postData.author_name};

                // store original column index to check if the iso is being moved
                // this.originalColumnIndex = this.postData.column_index;
            },
            updatePost() {
                if (this.validateForm()) {
                    axios.post('api/summary-board/update-post', {
                        id: this.id,
                        company_name: this.company_name,
                        company_type: this.company_type,
                        lines_of_business: this.lines_of_business,
                        client_type: this.client_type,
                        contract_type: this.contract_type,
                        contact_name: this.contact_name,
                        contact_number: this.contact_number,
                        email_address: this.email_address,
                        // opportunity_owner: this.opportunity_owner,
                        division: this.division,
                        decision_maker: this.decision_maker,
                        annual_jobs: this.annual_jobs,
                        average_fee: parseInt(this.average_fee.replace(/[^0-9]/g, '')),
                        annual_value: parseInt(this.annual_value.replace(/[^0-9]/g, '')),
                        next_steps: this.next_steps,
                        due_date: this.due_date,
                        close_by_date: this.close_by_date,
                        pipeline_stage: this.pipeline_stage,
                        notes: this.notes,
                        // author_id: authorId,
                        // author_name: authorName,
                        author_id: this.opportunity_owner._id,
                        author_name: this.opportunity_owner.name,
                    })
                    .then(() => {
                        this.getAllBoardPostData();
                        this.$emit('formSubmitted');
                    })
                    .catch((error) => {
                        console.log(error.response);

                        if (error.response.status === 403) {
                            this.validation.msg = 'Permission denied. You cannot edit other users ISO\'s';
                            this.validation.error = true;
                        } else {
                            this.validation.msg = '';
                            this.validation.error = false;
                        }

                    });
                }
            },
            deletePost() {
                axios.post('api/summary-board/delete-opportunity', {
                    id: this.id,
                    author_id: this.opportunity_owner._id,
                })
                .then(() => {
                    this.getAllBoardPostData();
                    this.$emit('formSubmitted');
                })
                .catch((error) => {
                    console.log(error);

                    if (error.response.status === 403) {
                        this.validation.msg = 'Permission denied. You cannot delete other users ISO\'s';
                        this.validation.error = true;
                    } else {
                        this.validation.msg = '';
                        this.validation.error = false;
                    }
                });
            },
            closeModal(){
                // remove errors
                this.validation.error = false;
                // emit toggle event to close form
                this.$emit('toggle');
            },
            calculateAnnualValue() {
                let anJobs = Math.trunc(this.annual_jobs);
                let avFee = this.average_fee.toString().replace(/[^0-9]/g, '');

                if (anJobs !== '' && anJobs > 0 && avFee !== '') {
                    this.annual_jobs = anJobs;
                    this.average_fee = '£' + parseInt(avFee).toLocaleString('en-GB');
                    this.annual_value = '£' + parseInt(anJobs * avFee).toLocaleString('en-GB');
                } else {
                    this.annual_value = '';
                }
            },
            validateForm() {
                // if iso is being moved to the first column we don't need to check the date
                if (this.pipeline_stage > 0) {
                    // if the iso is being moved to a new column
                    if ( this.pipeline_stage !== this.postData.column_index ) {
                        // if date is set
                        if ( this.due_date !== '' ) {
                            this.validation.error = false;
                            return true;
                        }

                        this.validation.msg = 'Error: Due Date is Required.';
                        this.validation.error = true;
                        return false;
                    }

                    this.validation.error = false;
                    return true;
                } else {
                    this.validation.error = false;
                    return true;
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    #opp_form_modal{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-color: #fff;
        border: 0.3rem solid #6693bc;

        .close_button{
            position: absolute;
            top: 1rem;
            right: 1rem;

            line{
                stroke: #1f2527;
                stroke-width: .3rem;
                stroke-linecap: round;
            }
        }

        

        form{
            display: flex;
            flex-wrap: wrap;
            width: 80rem;
            padding: 5rem 3.5rem;

            p{
                // font-size: 3rem;
                text-align: center;
                width: 100%;


                font-size: 4rem;
                line-height: 1.3;
                font-weight: 600;
                color: #6693bc;
                margin-bottom: 5rem;
            }

            label{
                width: 33.33333%;
                font-size: 1.8rem;
                line-height: 1.3;
                font-weight: 600;
                padding: 0 1.5rem;
                margin-bottom: 1.5rem;
                color: #6693bc;

                &:nth-of-type(12){
                    margin-bottom: 3rem;
                }

                &:nth-of-type(20){
                    width: 100%;
                    // margin-bottom: 3rem;
                }

                input{
                    display: block;
                    width: 100%;
                    margin-top: 0.5rem;
                    border: 0.1rem solid #355364;
                    font-size: 1.6rem;
                    line-height: 1.3;
                    font-weight: 500;
                    color: #355364;
                    padding: 0.25rem 0.5rem;
                }

                textarea{
                    display: block;
                    width: 100%;
                    margin-top: 0.5rem;
                    border: 0.1rem solid #355364;
                    font: unset;
                    font-size: 1.6rem;
                    line-height: 1.3;
                    font-weight: 500;
                    color: #355364;
                    height: 6em;
                    padding: 0.25rem 0.5rem;
                }

                /* Firefox remove arrows*/
                input[type=number] {
                   -moz-appearance: textfield;
                }
                /* Chrome, Safari, Edge, Opera - remove arrows*/
                input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                // textarea{
                //     display: block;
                //     width: 100%;
                //     margin-top: 0.5rem;
                // }

                select{
                    display: block;
                    width: 100%;
                    margin-top: 0.5rem;
                    border: 0.1rem solid #355364;
                    font-size: 1.6rem;
                    line-height: 1.3;
                    font-weight: 500;
                    color: #355364;
                    padding: 0.25rem 0.5rem;
                }
            }

            button{
                // margin: 1.5rem auto 0 auto;
                font-size: 2rem;
                line-height: 1.3;
                font-weight: 600;
                color: #fff;
                background-color: #6693bc;
                border: 0;
                padding: 1rem;
                width: 25%;
                display: flex;
                justify-content: center;
                align-items: center;

                &:nth-of-type(1) {
                    margin: 1.5rem 0 0 1.5rem;
                }

                &:nth-of-type(2) {
                    margin: 1.5rem auto 0 auto;
                }

                &:nth-of-type(3) {
                    margin: 1.5rem 1.5rem 0 0;
                }

                svg {
                    width: 2.4rem;
                    height: auto;
                    fill: #fff;
                }
            }

            #confirm-delete {
                position: absolute;
                background-color: #fff;
                border: 0.3rem solid #6693bc;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                padding: 3rem;
                display: flex;
                flex-wrap: wrap;
                width: 34rem;

                .open {
                    display: flex;
                }

                p {
                    font-size: 2rem;
                    width: 100%;
                    margin-bottom: 3rem;
                }

                button {
                    margin: 0 auto;
                    width: 33%;
                    padding: 0.8rem;
                    font-size: 1.6rem;
                }
            }

            .form-error {
                display: flex;
                flex-wrap: wrap;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #fff;
                border: 0.3rem solid #6693bc;
                padding: 3rem;

                p {
                    font-size: 1.8rem;
                    margin: 0 0 2rem 0;
                    width: 100%;
                }

                button {
                    margin: 0 auto;
                }
            }
        }      
    }
</style>